import axios from "axios";
import { EventBus } from './event-bus.js';
import constants from "../constants";

export default {

    saveProcess(appId, processId, applicationProcess, copyProcess) {
        axios.defaults.withCredentials = true;


        return axios.post(constants.BASE_URL + "/applications/" + appId + "/appprocesses/" + processId + "" + "/copy/" + copyProcess, applicationProcess)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            })
    },
    getProcessDetails(appId, processId) {
        axios.defaults.withCredentials = true;
        var msgType = "Success";
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appprocesses/" + processId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "Error";
            })
            .finally(() => {
                let notification = {
                    "msg": "success"
                }
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', notification);
                }
            });
    },
    getApplicationDetails(appId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let notification = {
                    "msg": "Error"
                }
                EventBus.$emit('error-notification', notification);
            })
    },

    disableApplicationProcess(appId, processId, deletedReason) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/applications/" + appId + "/appprocesses/" + processId + "/copy/false/delete", {"deletedReason":deletedReason}).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    enableApplicationProcess(appId, processId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/applications/" + appId + "/appprocesses/" + processId + "/copy/false/restore").then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    getProcesses(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/applications/0/appprocesses?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching application processes"
                    });
                }
            });
    },
    copyProcess(appId, processId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/applications/" + appId + "/appprocesses/copy/" + processId).then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    getMultipleProcessCopyInfo(processIds) {
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/applications/0/appprocesses/copy-multiple", null , {params:{processIds:processIds}}, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process copy details"
                    });
                }
            });
    },
    copyMutlipleProcesses(appProcesses) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/applications/0/appprocesses/save-multiple", appProcesses)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            })
    },

}
